<template>
  <div>
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-12 mt-5">
            <h1 class="font-weight-bold roboto-style title">World-class, reliable software solutions for your business</h1>
          </div>
        </div>
        <div class="row description inter-style medium-grey mt-2">
          <div class="col-lg-7 col-md-12">
            <p>We apply our talents and expertise from various industries to bring your idea to life and make your business more profitable.</p>
          </div>
        </div>
        <icons_row v-if="width > 1027"></icons_row>
        <div v-bind:class="['row', {'container-paddingb': width > 1025}]" v-bind:style="width <= 1025 ? 'margin-top: 30px;': ''">
          <div class="col-md-12 mb-5">
            <router-link class="font-weight-bold d-inline-block dark-grey button greenbtn bigbtn roboto-style" to="start-a-project">
              Start a project
              <arrow></arrow>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="width >= 1024" class="row border-top"></div>
    <div class="row" v-bind:style="width > 1023 ? 'padding-top: 36px;padding-bottom:36px' : ''">
      <div class="container">
        <div class="row" >
          <div class="col-md-2 d-flex align-self-center">
            <p class="align-self-center roboto-style font-weight-bold" v-bind:style="width <= 1020 ? 'font-size: 13px;margin-bottom: 30px;' : 'margin-bottom:0'"><b>Trusted by</b></p>
          </div>
          <div class="col-lg-10 col-md-12" style="padding: 0 13px;">
            <div v-bind:class="['row', 'm-0 text-center', {'text-center': width >= 1025}]">
              <div v-bind:class="['col-lg-1 col-md-6 col-6 icon p-0 d-flex align-self-center', {'justify-content-center': width <1024}]"> <img v-bind:class="['groupon-logo', {'align-self-center':width>1024}]" src="../assets/groupon.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 icon p-0 d-flex align-self-center',{'justify-content-center': width <1024}]"><img v-bind:class="['vodafone-logo',{'align-self-center':width>1024}]" src=".././assets/vodafone.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 icon p-0 d-flex align-self-center',{'justify-content-center': width <1024}]"><img v-bind:class="['gdfsuez-logo',{'align-self-center':width>1024}]" src=".././assets/gdf-suez.png"/></div>
              <div class="col-lg-1 col-md-6  col-6 icon p-0"><img class="orange-logo" src=".././assets/orange.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 icon p-0 mt-lg-0 d-flex align-self-center',{'justify-content-center': width <1024}]"><img v-bind:class="['ferrero-logo',{'align-self-center':width>1024}]" src=".././assets/ferrero.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 icon p-0 mt-lg-0 d-flex align-self-center',{'justify-content-center': width <1024}]"><img v-bind:class="['cocacola-logo',{'align-self-center':width>1024}]" src=".././assets/coca-cola.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 icon p-0 mt-lg-0 d-flex align-self-center',{'justify-content-center': width <1024}]"><img v-bind:class="['carlsberg-logo',{'align-self-center':width>1024}]" src=".././assets/carlsberg.png"/></div>
              <div v-bind:class="['col-lg-1 col-md-6  col-6 p-0 icon mt-lg-0 d-flex align-self-center',{'justify-content-center': width <1024}]" v-bind:style="width > 1025 ? 'text-align: right;max-width: 4%;' : ''"><img v-bind:class="['unilever-logo',{'align-self-center':width>1024}]" src=".././assets/unilever.png"/></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-container roboto-style row container-paddingt container-paddingb" v-bind:style="width <= 1025 ? 'mt-3' : ''">
      <div class="container">
        <div class="row mb-3">
          <h1 class="white title col-lg-8 col-md-12">Why Unknown Software</h1>
        </div>
        <div class="row inter-style">
          <div class="col-lg-3 col-md-12">
            <icon1></icon1>
            <p class="white description mt-2 mb-2 col-md-8 px-0">A very short response time</p>
            <p class="small-description light-grey">
              Past your deadlines? Don’t worry. We have great experience working with enterprises and middle-management. Our internal processes are very efficient which translates into a more rapid revenue.
            </p>
          </div>
          <div class="col-lg-3 col-md-12">
            <icon2></icon2>
            <p class="white description mt-2 mb-2">30 days of free maintenance</p>
            <p class="small-description light-grey ">
              Our job doesn’t end after we deliver the product. We will support you 30 days after delivery for free and solve any problem that may arise.
            </p>
          </div>
          <div class="col-lg-3 col-md-12">
            <icon3></icon3>
            <p class="white description mt-2 mb-2">High-performance products for your business</p>
            <p class="small-description light-grey ">
              The devil lies in the details. What’s the server response time or the loading time for end user, is the code scalable, is the new app interconnected to the other already established systems? We take care to deliver a final product that runs smoothly.
            </p>
          </div>
          <div class="col-lg-3 col-md-12">
            <icon4></icon4>
            <p class="white description mt-2 mb-2 col-md-8 px-0">Unexpected revenue</p>
            <p class="small-description light-grey ">
              You will enjoy cost savings in the long run since we are agile and deliver exceptional quality, so you save time, resources, and money. That simple!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="overflow: hidden">
      <div class="container container-paddingt container-paddingb">
        <div class="row">
          <h1 class="col-lg-8 col-md-12 title dark-grey roboto-style mb-0">Core services</h1>
        </div>
        <div v-bind:class="['row inter-style font-weight-normal', {'mt-5 mb-5' : width > 992}]">
          <div class="col-lg-6 col-md-12">
            <div class="row">
              <div class="col-lg-6 col-md-12 xs_margint">
                <p class="description dark-grey">Enterprise Software Development</p>
                <p v-bind:class="['small-description medium-grey', {'mb-0' : width <= 768}]">We work with complex software processes that use cutting edge, stable and long-term support technologies in order to deliver scalability, performance, and interconnectivity in the sense of interaction with the other tools and software the business already uses.</p>
              </div>
              <div class="col-lg-6 col-md-12 xs_margint">
                <p class="description dark-grey">Business automation system</p>
                <p v-bind:class="['small-description medium-grey', {'mb-0' : width <= 768}]">Automated business processes tailored to your specific needs. We offer solutions that truly transform your business digitally. It’s time for greater productivity, better customer service, increased efficiency, and improved accuracy. </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-12 xs_margint">
                <p class="description dark-grey">Infrastructure Management</p>
                <p class="small-description medium-grey mb-0">We provide structure and control of all the functions responsible for your technical needs, such as hardware, software, and networking. To minimize downtime and maintain business productivity we offer you 24/7 support.</p>
              </div>
              <div class="col-lg-6 col-md-12 xs_margint">
                <p class="description dark-grey">Bringing your MVP to life</p>
                <p class="small-description medium-grey mb-0">We can turn ideas into viable products and prototypes. Thanks to a team of vetted developers, designers, and product managers, we will rapidly test, apply new technologies and develop a launch-ready product.</p>
              </div>
            </div>
            <div v-bind:class="['row xs_margint', {'mb-5 mt-5': width > 992}, {'mb-3': width <= 992}]">
              <div class="col-md-12">
                <router-link class="font-weight-bold button roboto-style dark-grey smallbtn greenbtn" to="services">
                  View all our services
                  <arrow></arrow>
                </router-link>
              </div>
            </div>
          </div>
          <span v-if="width >= 992" class="col-lg-6 col-md-4" style="margin-top: -30px;">
        <services-icn></services-icn>
      </span>
        </div>
      </div>
    </div>
    <howwework></howwework>
    <div v-if="width > 1025" class="row border-top"></div>
    <testemonials></testemonials>
    <conversation></conversation>
  </div>
</template>

<script>
    import Arrow from '.././components/arrow';
    import Icon1 from '.././components/icon1';
    import Icon2 from '.././components/icon2';
    import Icon3 from '.././components/icon3';
    import Icon4 from '.././components/icon4';
    import ServicesIcn from '.././components/servicesicn';
    import testemonials from './testemonials';
    import icons_row from './icons_row';
    import conversation  from "./conversation";
    import howwework from "./howwework";

    export default {
        name: 'app',
        components: {
            Arrow: Arrow,
            Icon1: Icon1,
            Icon2: Icon2,
            Icon3: Icon3,
            Icon4: Icon4,
            ServicesIcn: ServicesIcn,
            testemonials,
            icons_row,
            conversation,
            howwework
        },
        data() {
            return {
                width: 0
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        mounted() {
            this.width = window.innerWidth;
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/homepage.vue